import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const tasksPlugin = createPlugin({
  id: 'tasks',
  routes: {
    root: rootRouteRef,
  },
});

export const TasksPage = tasksPlugin.provide(
  createRoutableExtension({
    name: 'TasksPage',
    component: () =>
      import('./components/TaskComponent').then(m => m.TaskComponent),
    mountPoint: rootRouteRef,
  }),
);
